import { render } from "./EditPages.vue?vue&type=template&id=233044dc&scoped=true"
import script from "./EditPages.vue?vue&type=script&lang=js"
export * from "./EditPages.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=233044dc&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233044dc"]])

export default __exports__